import Dexie from 'dexie'

const db = new Dexie('MobileProfileDB')

db.version(1).stores({
  config: 'key',
  profile: 'id',
  qualifications: 'id, status, expiry_date',
  leaveBalance: 'id',
  leaveRequests: '++localId, id, status, syncStatus',
  checkins: '++localId, id, timestamp, syncStatus',
  bookings: 'id, date',
  syncLog: '++id, timestamp, status',
})

export default db
